// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-card-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.legend-dot {
  width: 26px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
}

.legend-outline-box {
  width: 46px;
  height: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: #fcfcfc;
}

.chart-render-container {
  width: 100%;
  min-height: 240px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/StackedBarCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".chart-card-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n}\n\n.legend-dot {\n  width: 26px;\n  height: 12px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.legend-outline-box {\n  width: 46px;\n  height: 18px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: #fcfcfc;\n}\n\n.chart-render-container {\n  width: 100%;\n  min-height: 240px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
